import PropTypes from 'prop-types';
import styles from './HeaderTextAnimation.module.css';

function HeaderTextAnimation({ children, fullWidth }) {
  return (
    <div
      className={`aaco-clip-animation h-[68px] md:h-[139px] ${
        fullWidth ? 'w-full' : 'w-fit'
      }  ${styles.reveal} `}
    >
      {children}
    </div>
  );
}

HeaderTextAnimation.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
};

HeaderTextAnimation.defaultProps = {
  children: null,
  fullWidth: false,
};

export default HeaderTextAnimation;
